module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-3.daf3d64b.jpg";